import { takeEvery, put } from "redux-saga/effects";
import api from "../../services/api";
import { ENDPOINT } from "../../services/apiUrls";
import {
  getImagesByType,
  deleteImage,
  updateImageData,
  getAllImageTypes,
  saveImageTypes,
  bulkUploadImages,
} from "../slices";
import { toastError } from "../../utils/react-toaster";
import {
  getErrorMessage,
  pos_errormap_with_label,
} from "../../helpers/errors-helper";

async function commonPostData(url: string, data: any) {
  try {
    const postApi = api.request({
      method: "POST",
      url: url,
      data,
    });
    const fetchResponse = await postApi;
    return fetchResponse;
  } catch (e) {}
}
export interface ResponseGenerator {
  config?: any;
  data?: any;
  headers?: any;
  request?: any;
  status?: number;
  statusText?: string;
  code?: string;
}

function* updateGalleryImageData(actions: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `POST`,
      url: ENDPOINT.GALLERY.updateImageApi,
      data: actions.payload.dataToPost,
    });
    actions.payload?.callback && actions.payload.callback(response);
  } catch (error) {
    toastError("Please try again!");
    console.log(error);
  }
}

function* deleteGalleryImage(actions: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `POST`,
      url: ENDPOINT.GALLERY.deleteImageApi + actions.payload.imageId,
    });
    actions.payload?.callback && actions.payload.callback(response);
  } catch (error) {
    console.log(error);
  }
}

function* fetchAllImagesTypes(actions: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `GET`,
      url: ENDPOINT.GALLERY.getImageTypesApi,
    });
    yield put(saveImageTypes(response));
    actions.payload?.callback && actions.payload.callback(response);
  } catch (error) {
    console.log(error);
  }
}

function* fetchAllGalleryImages(actions: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `POST`,
      url: ENDPOINT.CATALOG.getImageGalleryApi,
      data: actions.payload.dataToPost,
    });
    if (response) {
      actions.payload.callback && actions.payload.callback(response);
    }
    // yield put(saveGalleryImages(response));
  } catch (error) {
    console.log(error);
  }
}

function* uploadImages(actions: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `POST`,
      url: ENDPOINT.GALLERY.bulkUploadApi,
      data: actions.payload.dataToPost,
    });

    if (!response?.code) {
      actions.payload.callback && actions.payload.callback(true);
    } else {
      actions.payload.callback && actions.payload.callback(false);
    }

    if (response?.code && pos_errormap_with_label[response?.code]) {
      toastError(
        getErrorMessage(
          pos_errormap_with_label,
          response?.code,
          actions.payload.dataToPost?.images?.length || 0
        )
      );
    }
    // yield put(saveGalleryImages(response));
  } catch (error) {
    actions.payload.callback && actions.payload.callback(false);
    console.log(error);
  }
}

export default function* root() {
  yield takeEvery(deleteImage.type, deleteGalleryImage);
  yield takeEvery(updateImageData.type, updateGalleryImageData);
  yield takeEvery(getAllImageTypes.type, fetchAllImagesTypes);
  yield takeEvery(getImagesByType.type, fetchAllGalleryImages);
  yield takeEvery(bulkUploadImages.type, uploadImages);
}
